import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { AppHeader } from '../app-header';
import { AreaContent, AreaAside } from '../area-layout';
import { IUniformLayoutProps } from './interfaces';

export function UniformLayout(props: IUniformLayoutProps) {
  const { children, titleZone, launchbox, disableAppHeader = false, isEditMode = false } = props;

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh" className={isEditMode ? 'ViewEditMode' : ''}>
      {!disableAppHeader && <AppHeader />}
      {titleZone || null}
      {isEditMode ? (
        <Grid container spacing={2} sx={{ minWidth: 800, maxWidth: 1400, margin: '0 auto', width: '100%', flexWrap: 'nowrap' }}>
          <AreaContent>
            <Box sx={{ '& .MuiAccordion-root.Mui-expanded:last-of-type': { marginBottom: 2 } }}>{children || null}</Box>
          </AreaContent>
          {launchbox && <AreaAside>{launchbox}</AreaAside>}
        </Grid>
      ) : (
        children
      )}
    </Box>
  );
}
